require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-paul-popat-reason-react-electron-boilerplate.json") })
        }
      }, "path---package-unpublished-paul-popat-reason-react-electron-boilerplate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-paul-popat-reason-react-electron-boilerplate!./.cache/json/package-unpublished-paul-popat-reason-react-electron-boilerplate.json
// module id = 951
// module chunks = 231608221292675